// extracted by mini-css-extract-plugin
export default {"pagination-container":"CommonPagination_pagination-container__XCyZs","active":"CommonPagination_active__uxD3h"};